import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'pending-app-cip',
  template: require('./pending-app-cip.component.html')
})
export class PendingAppCipComponent extends BaseRoute {

  requestId = 'testing';
  appType = 'testing';

  constructor(injector: Injector) {
    super(injector);
    this.loadingNext = false;
  }

  ngOnInit() {
    this.requestId = this.appActions.getData('requestId', 123456789);
    this.appType = this.appActions.getData('appType') === 'tks' ? 'Self-Directed' : 'Managed';
    this.appActions.setData('stepUserIsOn', 0);
  }

  backToAlly() {
    this.loadingNext = true;
    if (this.flowManager.isAuthed) {
      this.flowManager.ssoToAlly();
    } else {
      this.flowManager.canUnload = true;
      window.location.href = 'https://www.ally.com';
    }
  }
}
